module.exports = __webpack_public_path__ + "static/media/anuragThakur.367b5780.png";